import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-field-errors',
  templateUrl: './field-errors.component.html',
  styleUrls: ['./field-errors.component.css']
})
export class FieldErrorsComponent {
  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() prefix = 'error';

  getCompleteKey(partial: string) {
    return `${ this.prefix }.${ partial }`;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/forms/field-errors/field-errors.component.ts